import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import PageNotFound from "./components/PageNotFound";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Companies from "./components/Companies";
import UserManagement from "./components/UserManagement";
import Sendsms from "./components/Messages/Sendsms";
import Draftsms from "./components/Messages/Draftsms";
import Trashsms from "./components/Messages/Trashsms";
import Contacts from "./components/Contacts";
import Statement from "./components/Statement";
import Failedsms from "./components/Messages/Failedsms";
import Recentsms from "./components/Messages/Recentsms";
import Sidebar from "./components/Layout/Sidebar";
import Dashboard from "./components/Layout/Dashboard";
import NewMessage from "./components/Messages/NewMessage";
import axios from "axios";
import { API_URL, secret_key } from "./components/Constants";
import SendNewMessage from "./components/Messages/SendNewMessage";
import ContactsByGroup from "./components/ContactsByGroup";
import ContactGroupsForCompany from "./components/ContactGroupsForCompany";
import PasswordReset from "./components/PasswordReset";
import ImportMessages from "./components/Messages/ImportMessages";
import ImportLines from "./components/Messages/ImportLines";
import CryptoJS from "crypto-js";
import loading1 from "./assets/loading.gif"
import CompanyCreditHistory from "./components/CompanyCreditHistory";
import Customfiltersms from "./components/Messages/Customfiltersms";
import Filterrecentsms from "./components/Messages/Filterrecentsms";
import CompanyStatistics from "./components/CompanyStatistics";
import TopUpHistory from "./components/TopUpHistory";
import VisualsDashboard from "./components/Layout/VisualsDashboard";
import UserManual from "./components/UserManual";


function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

useEffect(() => {
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';
  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = decryptedToken

  if (token) {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/verify`,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.data.message === 1) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch((error) => {
        setIsAuthenticated(false);
      })
      .finally(()=>{
        setLoading(false);
      });
  } else {
    setIsAuthenticated(false);
    setLoading(false);
  }
}, []);

  
  return (
    <>
      <BrowserRouter>
      {loading ? (
          <div className="loadingcontainer">
            <img className="loadingimg" src={loading1} alt="" />
          </div>
        ) : (
        <Routes>
           <Route path="/" element={isAuthenticated ? <Sidebar /> : <Navigate to="/login" replace />}>
              <Route path="" element={<Dashboard />} /> 
              <Route path="visuals_dashboard" element={<VisualsDashboard />} />
              <Route path="new_message" element={<NewMessage />} />
              <Route path="sent" element={<Sendsms />} />
              <Route path="draft" element={<Draftsms />} />
              <Route path="archive" element={<Trashsms />} />
              <Route path="contact_groups" element={<ContactGroupsForCompany />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="topup_history" element={<TopUpHistory />} />
              <Route path="statement" element={<Statement />} />
              <Route path="company_stats" element={<CompanyStatistics />} />
              <Route path="failed_sms" element={<Failedsms />} />
              <Route path="recent_sms" element={<Recentsms />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="companies" element={<Companies />} />
              <Route path="prev_message/:id" element={<SendNewMessage />} />
              <Route path="contactlist/:groupid" element={<ContactsByGroup />} />
              <Route path="imported_messages" element={<ImportMessages/>} />
              <Route path="import_lines/:id" element={<ImportLines />} />
              <Route path="units_history/:companyid" element={<CompanyCreditHistory />} />
              <Route path="recent_filter" element={<Filterrecentsms />} />
              <Route path="custom_filter" element={<Customfiltersms />} />
              <Route path="user_manual" element={<UserManual />} />
          </Route>
          
          <Route
            path="/login"
            element={
              isAuthenticated ? <Navigate to="/" replace /> : <Login />
            }
          />           
          <Route path="/register" element={<Register />}/>
          <Route path="/password_reset" element={<PasswordReset />}/>
          <Route
            path="*"
            element={
              isAuthenticated ? <PageNotFound /> : <Navigate to="/login" replace />
            }
          />
        </Routes>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
